import React from "react";
import "../App.css";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import Popovers from "react-bootstrap/Popover";
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.min.css";
import "react-datepicker/dist/react-datepicker.css";
import {
  getEquipmentDetails,
  getEquipmentHistory,
  getEquipmentInfo,
  getShipsCount,
  getShipDeatil,
  getShipEquipmentSearchlist,
  deleteEquipmentHistory,
} from "../Actions/ShipEquipmentDetailsAPI";
import { GetEquipmentHistory } from "../helpers/api";
import { DownloadAttachment } from "../Actions/AttachmentAPI";
import {
  getEquipmentServiceTypeList,
  DownloadAttachmentServiceImages,
} from "../Actions/CommonAPI";
import { getServiceTypeList } from "../Actions/CommonAPI";
import userRoles from "../helpers/role";
import * as moment from "moment";
import { confirmAlert } from "react-confirm-alert";
import { t } from "i18next";
import { OverlayTrigger } from "react-bootstrap";
import i18n from "./DropdownLanguage/i18n";
import axios from "axios";
import API, { shipNames } from "../helpers/api";
import FileSaver from "file-saver";
import Modal from "react-bootstrap/Modal";
import { DropzoneArea } from "material-ui-dropzone";
import { FileCopy, Close, Height, HeightTwoTone, Folder } from "@material-ui/icons";
import Role from "../helpers/role";
import { use } from "react";

let user = localStorage.getItem("UserRoles");

// Reload everything:
function reload() {
  console.log("refresh");
}
class ShipDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchEquipment: {
        equipment: "",
        next_due_in_from: "",
        next_due_in_to: "",
        pagesize: 25,
        pagenumber: 1,
        ServiceTypes: [],
        shipId: "",
        isTotalShips: true,
        isOverdueShips: false,
        isShipsDue10: false,
        isShipsDue30: false,
        isShipsDue60: false,
        isShipsDue90: false,
      },
      ModalOpen: false,
      updateGuid: '',
      selectedFile: null
    };
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    if (match.params.id) {
      dispatch(getEquipmentInfo(match.params.id));
      dispatch(getEquipmentServiceTypeList(match.params.id));
      dispatch(getEquipmentHistory(match.params.id));
    }
  }

  componentDidUpdate(prevProps) {
    const { dispatch, match } = this.props;

    if (match.params.id && match.params.id !== prevProps.match.params.id) {
      dispatch(getEquipmentInfo(match.params.id));
      dispatch(getEquipmentServiceTypeList(match.params.id));
      dispatch(getEquipmentHistory(match.params.id));
    }
  }
  componentDidUpdate(prevProps) {
    const { dispatch, match } = this.props;

    if (match.params.id && match.params.id !== prevProps.match.params.id) {
      dispatch(getEquipmentInfo(match.params.id));
      dispatch(getEquipmentServiceTypeList(match.params.id));
      dispatch(getEquipmentHistory(match.params.id));
    }
  }

  /*  componentDidUpdate() {
     const { dispatch, match } = this.props;
     window.onpopstate = (e) => {
       //your code...
       this.props.dispatch({ type: "ShowEquipmentDetails", data: false });
       // this.props.history.push("/Home");
       //   this.props.history.goBack();
     };
     if (window.history.replaceState) {
       window.history.replaceState(
         null,
         null,
         `/Home/ShipDetails/${match.params.shipId}`
       );
     }
     // if (window.history.replaceState) {
     //   window.history.replaceState(
     //     null,
     //     null,
     //     "/Home/MMPLDashboard",
     //     "AccountRegister",
     //     new { page: 1 }()
     //   );
     // }
     //   if (window.history.replaceState) {
     //     window.history.replaceState(null, null, "@Url.Action("PendingList", "AccountRegister" , new { page = 1 })");
     // }
     // if (
     //   window.performance.getEntriesByType("navigation")[0].type != "navigate"
     // ) {
     //   console.log("reload");
     // }
   } */

  ShowSidePanel = () => {
    this.props.dispatch({ type: "ShowEquipmentDetails", data: false });
    // this.props.history.push("/Home");
    this.props.history.goBack();
  };
  deleteEquipmentHistory = (serviceId) => {
    const { t } = this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const { dispatch, match } = this.props;
            const { id } = match.params;
            dispatch(deleteEquipmentHistory(id, serviceId));
          }
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => { }
        }
      ]
    });
  };
  renderShipNotes(props) {
    const { t } = this.props;
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>
            {t("CommonText.Download")}
          </label>
        </Popovers.Content>
      </Popovers>
    );
  }
  renderShipDelete(props) {
    const { t } = this.props;
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>
            {t("CommonText.Delete")}
          </label>
        </Popovers.Content>
      </Popovers>
    );
  }
  render() {
    const { equipmentDetail, t } = this.props;
    const isArabic = i18n.language === 'arab'
    return (
      <div className="row">
        <div className="full-height pt-3">
          <div className="grey-bg course-list-page">
            <div className="panel-box search-filter-box mb-4">
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                onClick={() => this.ShowSidePanel()}
                style={{ display: 'inline-flex', alignItems: 'center' }}
              >
                <span style={{ marginTop: '-1px' }}>&larr;</span>{t("CommonText.Return")}
              </button>

              <div className="resource-list-auth-date">
                <div
                  className="card mt-2 MM-card-header"
                  style={{ backgroundColor: "white" }}
                >
                  <div className="card-body">
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {t("ShipDetailsScreen.EquipmentDetails")}
                    </h5>
                  </div>
                  <div className="search-filter-box mt-2">
                    <div className="row">
                      <div className="col-sm-6 mb-2">
                        <span>
                          <strong>{t("ShipEquipmentStatusScreen.EquipmentName")}: </strong>
                          <span>{equipmentDetail.equipment}</span>
                        </span>
                      </div>
                      <div className="col-sm-6 mb-2">
                        <span className={` ${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("ShipEquipmentStatusScreen.Type")} </strong>
                          <strong>:</strong>

                        </span>
                        <span>{equipmentDetail.equipmentType}</span>
                      </div>
                      <div className="col-sm-6 mb-2">
                        <span className={` ${isArabic ? 'arabic' : ''}`}>
                          <strong>{t("ShipEquipmentStatusScreen.Capacity")} / {t("ShipEquipmentStatusScreen.Size")}  </strong>
                          <strong>:</strong>
                          <span>{equipmentDetail.capacity}</span>
                        </span>
                      </div>
                      {equipmentDetail.equipment ?
                        equipmentDetail?.equipment.toLowerCase().includes("lifeboat") ?
                          <>
                            <div className="col-sm-6 mb-2">
                              <span>
                                <strong>{t("EditEquipmentScreenContent.LifeboatMake")} :{" "} </strong>
                                {equipmentDetail?.lifeboatMake}{" "}
                              </span>
                            </div>
                            <div className="col-sm-6 mb-2">
                              <span>
                                <strong> {t("EditEquipmentScreenContent.Davit/winchMake")} :{" "} </strong>
                                {equipmentDetail?.davitwinchMake}{" "}
                              </span>
                            </div>
                            <div className="col-sm-6 mb-2">
                              <span>
                                <strong> {t("EditEquipmentScreenContent.LifeboatModel")} :{" "} </strong>
                                {equipmentDetail?.lifeboatModel}{" "}
                                {equipmentDetail.model_AttachmentName ? (
                                  <i className="fa fa-download click ml-1" onClick={() => this.downloadDocument(
                                    equipmentDetail.model_AttachmentName, equipmentDetail.model_AttachmentGUID)} aria-hidden="true"
                                    style={{ color: " #1a3464", fontSize: "1.2rem" }}></i>) : ("")}
                              </span>
                            </div>
                            <div className="col-sm-6 mb-2">
                              <span>
                                <strong> {t("EditEquipmentScreenContent.LifeboatRelease")} :{" "} </strong>
                                {equipmentDetail?.lifeboatRelease}{" "}
                              </span>
                            </div>
                          </>
                          : equipmentDetail?.equipment?.toLowerCase().includes("rescue boat") ? <>
                            <div className="col-sm-6 mb-2">
                              <span>
                                <strong>{t("EditEquipmentScreenContent.rescueboatMake")} :{" "} </strong>
                                {equipmentDetail?.rescueboatMake}{" "}
                              </span>
                            </div>
                            <div className="col-sm-6 mb-2">
                              <span>
                                <strong>{t("EditEquipmentScreenContent.rescueboatDavit/winchMake")} :{" "} </strong>
                                {equipmentDetail?.rescueboatdavitwinchMake}{" "}
                              </span>
                            </div>
                            <div className="col-sm-6 mb-2">
                              <span>
                                <strong>{t("EditEquipmentScreenContent.rescueboatModel")} :{" "} </strong>
                                {equipmentDetail?.rescueboatModel}
                                {equipmentDetail.model_AttachmentName ? (
                                  <i className="fa fa-download click ml-1" onClick={() => this.downloadDocument(
                                    equipmentDetail.model_AttachmentName, equipmentDetail.model_AttachmentGUID)} aria-hidden="true"
                                    style={{ color: " #1a3464", fontSize: "1.2rem" }}></i>) : ("")}
                              </span>
                            </div>
                            <div className="col-sm-6 mb-2">
                              <span>
                                <strong> {t("EditEquipmentScreenContent.rescueboatRelease")} :{" "} </strong>
                                {equipmentDetail?.rescueboatRelease}{" "}
                              </span>
                            </div>
                          </> : <>
                            <div className="col-sm-6 mb-2">
                              <span className={` ${isArabic ? 'arabic_ship' : ''}`}>
                                <strong>{t("ShipEquipmentStatusScreen.Make")}  </strong>
                                <strong>:</strong>
                                {equipmentDetail?.make}{" "}
                              </span>
                            </div>
                            <div className="col-sm-6 mb-2">
                              <span className={` ${isArabic ? 'arabic_ship' : ''}`}>
                                <strong>{t("ShipEquipmentStatusScreen.Model")} </strong>
                                <strong>:</strong>
                                {equipmentDetail?.model}{" "} {equipmentDetail.model_AttachmentName ? (
                                  <i className="fa fa-download click ml-1" onClick={() => this.downloadDocument(
                                    equipmentDetail.model_AttachmentName, equipmentDetail.model_AttachmentGUID)} aria-hidden="true"
                                    style={{ color: " #1a3464", fontSize: "1.2rem" }}></i>) : ("")}
                              </span>
                            </div>
                          </> : <></>}

                      <div className="col-sm-6 mb-2">
                        <span className={` ${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("ShipEquipmentStatusScreen.ManufacturingDate")} </strong>
                          <strong>:</strong>

                        </span>
                        <span>{moment(equipmentDetail.manufracturingDate).format("DD MMM YYYY")}</span>
                      </div>
                      <div className="col-sm-6 mb-2">
                        <span className={` ${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("ShipEquipmentStatusScreen.Quantity")} </strong>
                          <strong>:</strong>

                        </span>
                        <span>{equipmentDetail.quantity}</span>
                      </div>
                      <div className="col-sm-6 mb-2">
                        <span>
                          <strong>{t("TopPaneContent.Category")}: </strong>
                          <span>{equipmentDetail.category}</span>
                        </span>
                      </div>
                      <div className="col-sm-6 mb-2">
                        <span>
                          <strong>{t("ShipEquipmentStatusScreen.AdditionalInformation")}: </strong>
                          <span>{equipmentDetail.additionalInformation}</span>
                        </span>
                      </div>
                      <div className="col-sm-6 mb-2">
                        <span className={` ${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("ShipEquipmentStatusScreen.LastDoneServiceType")} </strong>
                          <strong>:</strong>

                        </span>
                        <span>{equipmentDetail.serviceType}</span>
                      </div>
                      <div className="col-sm-6 mb-2">
                        <span className={` ${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("ShipEquipmentStatusScreen.LastDone")} </strong>
                          <strong>:</strong>

                        </span>
                        <span>
                          {moment(equipmentDetail.lastDone).format(
                            "DD MMM YYYY"
                          )}
                        </span>
                      </div>
                      <div className="col-sm-6 mb-2">
                        <span>
                          <strong>{t("ShipEquipmentStatusScreen.LastServicePort")}: </strong>
                          <span>{equipmentDetail.lastServicePort}</span>
                        </span>
                      </div>
                      <div className="col-sm-6 mb-2">
                        <span>
                          <strong>{t("ShipDetailsScreen.LastServiceCountry")}: </strong>
                          <span>{equipmentDetail.lastServiceCountry}</span>
                        </span>
                      </div>
                      <div className="col-sm-6 mb-2">
                        <span>
                          <strong>{t("ShipDetailsScreen.LastServiceProvider")}: </strong>
                          <span>{equipmentDetail.lastServiceProvider}</span>
                        </span>
                      </div>
                      <div className="col-sm-6 mb-2">
                        <span className={` ${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("ShipDetailsScreen.NextDue")} </strong>
                          <strong>:</strong>

                        </span>
                        <span>
                          {moment(equipmentDetail.nextDue).format(
                            "DD MMM YYYY"
                          )}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="card-body">
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}>
                      {t("ShipDetailsScreen.EquipmentServices")}
                    </h5>
                  </div>
                  <div className="search-filter-box history-box">
                    {this.renderCardData()}
                  </div>
                  <div className="card-body">
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {t("ShipDetailsScreen.ServiceHistory")}
                    </h5>
                  </div>
                  <div className="search-filter-box history-box">
                    {this.renderHistoryCard()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          size="lg"
          show={this.state.ModalOpen}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
          onHide={() => {
            this.setState({ ModalOpen: false, selectedFile: null, updateGuid: '' })
          }}
          className="borderCondition">
          <Modal.Header
            className="ClosebtnColor"
            closeButton
            style={{ backgroundColor: "#1a3464", color: "white" }}
          >
            <Modal.Title id="example-modal-sizes-title-sm">
              Upload Service Certificate
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row ">
              <div className="col-12 d-flex align-items-center justify-content-center mt-5">
                <div style={{ display: "flex", position: "relative" }}>
                  <Folder className="folderIcon" />
                  <DropzoneArea
                    onDrop={(files) => this.handleDropFiles(files)}
                    showPreviewsInDropzone={false}
                    maxFileSize={10000000}
                    dropzoneText={t('CommonText.UploadText')}
                    filesLimit={1}
                    style={{ height: '20px' }}
                    sx={{

                      '& .MuiDropzonePreviewList-root': {
                        display: 'none',
                      },
                      '& .MuiDropzoneArea-root': {
                        minHeight: '20px !important',
                      }
                    }}
                  />
                </div>
              </div>
              <div className="col-12 d-flex align-items-center justify-content-center mb-5 mt-2">
                {this.state?.selectedFile ? (
                  <span>{this.state.selectedFile.name}</span>
                ) : (
                  <span>No file selected</span>
                )}
              </div>
              <div className="col-12 d-flex justify-content-end">
                <button
                  onClick={() => { this.updateDocument(); }}
                  type="button"
                  className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-2"
                  style={{ backgroundColor: "rgb(26, 52, 100)" }}
                >
                  {`${t("EquipmentServiceTypes.Update")}`}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }

  renderHistoryCard() {
    const { equipmentHistory } = this.props;
    const isArabic = i18n.language === 'arab'
    return equipmentHistory && equipmentHistory.length ? (
      equipmentHistory.map((item, index) => {
        return (
          <>
            <div
              className="card MM-card-content mb-1"
              style={{
                backgroundColor: "#f0f0f0",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div className="p-3">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div
                      className={`${user === userRoles.mmpladmin
                        ? "col-sm-10 col-md-10 col-10"
                        : "col-sm-12 col-md-12 col-12"
                        } col-m-auto row`}
                    >
                      <div className="col-sm-6 mb-1">
                        <span className={` ${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("ShipDetailsScreen.SlNo")} </strong>
                          <strong>:</strong>

                        </span>
                        <span className="italicFont ">{index + 1}</span>
                      </div>
                      <div className="col-sm-6 mb-1">
                        <span className={` ${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("content.Servicetype")} </strong>
                          <strong>:</strong>

                        </span>
                        <span className="italicFont ">
                          {" "}
                          {item.serviceType}
                        </span>
                      </div>
                      <div className="col-sm-6 mb-1">
                        <span className={` ${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("ShipDetailsScreen.ServiceDate")} </strong>
                          <strong>:</strong>

                        </span>
                        <span className="italicFont ">
                          {" "}
                          {moment(item.serviceDate).format("DD MMM YYYY")}
                        </span>
                      </div>
                      <div className="col-sm-6 mb-1">
                        <span>
                          <strong>{t("ShipDetailsScreen.ServicePort")}: </strong>
                          <span className="italicFont"> {item.port}</span>
                        </span>
                      </div>
                      <div className="col-sm-6 mb-1">
                        <span>
                          <strong>{t("ShipDetailsScreen.ServiceCountry")}: </strong>
                          <span className="italicFont"> {item.country}</span>
                        </span>
                      </div>
                      <div className="col-sm-6 mb-1">
                        <span>
                          <strong>{t("ShipDetailsScreen.ServiceProvider")}: </strong>
                          <span className="italicFont">
                            {" "}
                            {item.serviceProvider}
                          </span>
                        </span>
                      </div>
                      {/*    <div className="col-sm-6 mb-1">
                        <span>
                          <strong>{t("ShipDetailsScreen.ActionDate")}: </strong>
                          <span className="italicFont">
                            {" "}
                            {item.modifiedDate ? moment(item.modifiedDate).format("DD MMM YYYY") : moment(item.createdDate).format("DD MMM YYYY")}
                          </span>
                        </span>
                      </div> */}
                      <div className="col-sm-12 mb-1">
                        <span>
                          <strong>{t("ShipDetailsScreen.Comments")}: </strong>
                          <span className="italicFont "> {item.remarks}</span>
                        </span>
                      </div>
                      <div className="col-sm-6">
                        <span>
                          <strong>{t("ShipDetailsScreen.ServiceCertificate")}: </strong>
                          <span className="italicFont ">
                            {item.attachmentName}
                          </span>
                          {item.attachmentName ? (
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={this.renderShipNotes()}
                            >

                              <i
                                className="fa fa-download ml-1 fa-lg click"
                                style={{ width: 20 }}
                                onClick={() =>
                                  this.downloadDocument(
                                    item.attachmentName,
                                    item.attachmentGuid
                                  )
                                }
                              ></i>
                            </OverlayTrigger>
                          ) : (
                            ""
                          )}
                        </span>
                      </div>
                      <div className="col-sm-6">
                        <span className={` ${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("ServiceBudgetHistory.ServicedQty")} </strong>
                          <strong>:</strong>

                        </span>
                        <span className="italicFont ">

                          {item.serviceQty ? item.serviceQty : 0}
                        </span>
                      </div>
                    </div>
                    {/* <div className="col-sm-8">
                      <span>
                        <strong>Service Photo: </strong>
                        {item.hasServiceImages && (
                          <i
                            className="fa fa-download ml-1 fa-lg click"
                            style={{ width: 20 }}
                            onClick={() =>
                              this.downloadServicesImages(
                                item.equipmentServiceId
                              )
                            }
                          ></i>
                        )}
                      </span>
                    </div> */}
                    {user === userRoles.mmpladmin && (
                      <div
                        className={
                          "col-sm-2 col-md-2 col-2 col-m-auto  align-self-center"
                        }
                      >
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={this.renderShipDelete()}
                        >
                          <i
                            className="fa fa-trash fa-2x px-2 click"
                            aria-hidden="true"
                            style={{ color: " #1a3464", fontSize: "1.8rem" }}
                            onClick={() =>
                              this.deleteEquipmentHistory(
                                item.equipmentServicehistoryId
                              )
                            }
                          ></i>
                        </OverlayTrigger>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      })
    ) : (
      <div
        className="card"
        style={{ overflow: "hidden", position: "relative" }}
      >
        <div class="container">
          <h6 className="resource-list-title no-item-card">
            {t("CommonText.NoHistory")}
          </h6>
        </div>
      </div>
    );
  }

  renderCardData = () => {
    const isArabic = i18n.language === 'arab'
    const { arraylist } = this.props;
    return arraylist && arraylist.length ? (
      arraylist.map((item, index) => {
        return (
          <div
            className="card MM-card-content mb-1"
            style={{
              backgroundColor: "#f0f0f0",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <div>
              {item.isOverDue ? (
                <div className="arrow-left-red"></div>
              ) : (
                <div className="arrow-left-green"></div>
              )}
            </div>
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-12 col-md-12 pb-2">
                    <h6 className="resource-list-title">
                      {item.serviceType ? item.serviceType : ""}
                    </h6>
                  </div>
                  <div className="col-sm-4">
                    <span>
                      <strong>{t("ShipEquipmentStatusScreen.EquipmentName")}: </strong>
                      <span className="italicFont">
                        {item.equipmentName ? item.equipmentName : ""}{" "}
                        {/* <span className={`badge badge-light ${item?.equipmentCategoryTypename?.toLowerCase() == "addon" ? "add-on-badge-light" : item?.equipmentCategoryTypename?.toLowerCase() == "adhoc" ? "add-hoc-badge-light" : "mandate-badge-light"} ml-2`}>
                          {item?.equipmentCategoryTypename}
                        </span> */}
                      </span>
                    </span>
                  </div>
                  <div className="col-sm-4">
                    <span className={` ${isArabic ? 'arabic_ship' : ''}`}>
                      <strong>{t("ShipDetailsScreen.ServiceDate")} </strong>
                      <strong>:</strong>

                    </span>
                    <span className="italicFont">
                      {item.serviceDate
                        ? moment(item.serviceDate).format("DD MMM YYYY")
                        : ""}
                    </span>
                  </div>
                  <div className="col-sm-4">
                    <span className={` ${isArabic ? 'arabic_ship' : ''}`}>
                      <strong>{t("ShipDetailsScreen.NextDue")}</strong>
                      <strong>:</strong>
                      {/* <i aria-hidden="true"></i>{" "} */}

                    </span>
                    <span className="italicFont">
                      {item.nextDueIn
                        ? moment(item.nextDueIn).format("DD MMM YYYY")
                        : ""}
                    </span>
                  </div>
                  <div className="col-sm-4 mt-2">
                    <span>
                      <strong>{t("ShipDetailsScreen.ServicePort")}: </strong>
                      <span className="italicFont">
                        {item.lastDonePort ? item.lastDonePort : ""}
                      </span>
                    </span>
                  </div>
                  <div className="col-sm-4 mt-2">
                    <span>
                      <strong>{t("ShipDetailsScreen.ServiceCountry")}: </strong>
                      <span className="italicFont">
                        {item.lastDoneCountry ? item.lastDoneCountry : ""}
                      </span>
                    </span>
                  </div>
                  <div className="col-sm-4 mt-2">
                    <span>
                      <strong>{t("ShipDetailsScreen.ServiceProvider")}: </strong>
                      <span className="italicFont">
                        {item.lastDoneServiceProvider
                          ? item.lastDoneServiceProvider
                          : ""}
                      </span>
                    </span>
                  </div>
                  <div className="col-sm-4 mt-2">
                    <span>
                      <strong>{t("ShipDetailsScreen.ServiceCertificate")}: </strong>
                      <span className="italicFont">{item.attachmentName}</span>
                      {item.attachmentName ? (
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={this.renderShipNotes()}
                        >
                          <i
                            className="fa fa-download ml-1 fa-lg click"
                            style={{ width: 20 }}
                            onClick={() =>
                              this.downloadDocument(
                                item.attachmentName,
                                item.attachmentGuid
                              )
                            }
                          ></i>
                        </OverlayTrigger>
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                  <div className="col-sm-4 mt-2">
                    <span>
                      <strong>{t("ShipDetailsScreen.ServicePhotos")}: </strong>
                      {/* <span className="italicFont">{item.attachmentName}</span> */}
                      {item.hasServiceImages && (
                        <i
                          className="fa fa-download ml-1 fa-lg click"
                          style={{ width: 20 }}
                          onClick={() =>
                            this.downloadServicesImages(item.equipmentServiceId)
                          }
                        ></i>
                      )}
                    </span>
                  </div>
                  <div className="col-sm-4 mt-2">
                    <span>
                      <strong>{t("DashboardShipReports.Remarks")}: </strong>
                      <span className="italicFont">
                        {item.remarks ? item.remarks : ""}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
    ) : (
      <div
        className="card"
        style={{ overflow: "hidden", position: "relative" }}
      >
        <div class="container">
          <h6 className="resource-list-title no-item-card">
            {t("CommonText.NoItem")}
          </h6>
        </div>
      </div>
    );
  };

  updateDocument() {
    if (this.state.selectedFile) {
      const data = new FormData();
      data.append('file', this.state.selectedFile);
      let url = `${API.AttachmentAPI}?id=` + this.state.updateGuid;
      axios
        .post(url, data)
        .then((response) => {
          this.setState({ ModalOpen: false, selectedFile: null, updateGuid: '' })
        })
        .catch((error) => {
          console.log(error, "error in file upload")
        });
    }
  }

  downloadDocument(attachmentName, attachmentGuid) {
    const { dispatch } = this.props;
    // dispatch(DownloadAttachment(attachmentName, attachmentGuid));
    let encodedAttachmentName = btoa(unescape(encodeURIComponent(attachmentName)));
    let url = `${API.DownloadAttachmentAPI}?filename=${encodedAttachmentName}&guidValue=${attachmentGuid}`;
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = "";
        blob = new Blob([response.data], { type: response.data.type });
        var mime = require('mime-types'),
          fileExtension = mime.extension(response.data.type)
        FileSaver.saveAs(blob, attachmentName + "." + fileExtension);
      })
      .catch((error) => {
        if (error.response) {
          const blobData = error.response.data;

          // Check if it's a Blob and of type application/json
          if (blobData instanceof Blob && blobData.type === "application/json") {
            blobData.text().then((text) => {
              // Parse the text into a JSON object
              try {
                const jsonData = JSON.parse(text);

                // Access the InnerException message
                const innerExceptionMessage = jsonData?.InnerException?.message;
                if (innerExceptionMessage == "The specified key does not exist.") {
                  if (user == userRoles.mmpladmin || user === userRoles.mmpl) {
                    this.setState({ ModalOpen: true, updateGuid: attachmentGuid });
                  }
                }
                console.log("Inner Exception Message:", innerExceptionMessage);

              } catch (parseError) {
                console.error("Failed to parse JSON:", parseError);
              }
            }).catch((textError) => {
              console.error("Error reading Blob text:", textError);
            });
          }
        }
        dispatch({
          type: "AttchmentUploadedFailure",
          error: "ERROR",
        });
      });
  }

  handleDropFiles = (files) => {
    console.log(files);
    if (files.length > 0) {
      this.setState({ selectedFile: files[0] }); // Store only the first file
    } else {
      this.setState({ selectedFile: null }); // Reset if no files are dropped
    }
  };
  downloadServicesImages(id) {
    const { dispatch } = this.props;
    dispatch(DownloadAttachmentServiceImages(id));
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    MIEuList: state.SidePanReducer.MIEuList,
    //BY BALU MOORTHI
    equipmentHistory: state.ShipEquipmentReducer.EquipmentHistory || [],
    equipmentDetail: state.ShipEquipmentReducer.EquipmentInfo || {},
    arraylist: state.SidePanReducer.EquipmentServiceTypeList || [],
  };
}
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ShipDetails));
